import {Component, Input, OnInit, signal} from '@angular/core';
import {Appointment, NgCaseInfo} from "@app/shared/interfaces/appointment.interface";
import {appointmentType} from "@app/shared/components/generic-dashboard/generic-dashboard.component";
import {
  AppointmentDetailData
} from "@app/shared/components/appointment-detail-modal/appointment-detail-modal.component";
import {CommonModule} from "@angular/common";
import {DocumentsTableComponent} from "@app/shared/components/documents-table/documents-table.component";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";

@Component({
  selector: 'app-appointment-detail',
  templateUrl: './appointment-detail.component.html',
  styleUrl: './appointment-detail.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    DocumentsTableComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
  ]
})
export class AppointmentDetailComponent implements OnInit {
  @Input() appointment!: Appointment;
  @Input() caseInfo: NgCaseInfo | null = null;
  @Input() showDocumentsTable: boolean = false;
  @Input() appointmentType?: appointmentType;
  @Input() isMultiAppointment: boolean = false;
  @Input() isExpanded: boolean = false;

  appointmentId?: string;

  detailSignal = signal<AppointmentDetailData | undefined>(undefined);

  ngOnInit(): void {
    if(this.isExpanded) {
      this.appointmentId = this.appointment.id;
    }
    const value = {
      appointmentId: this.appointment.id,
      patientId: this.appointment.patient.id,
      caseNumber: '',
      appointmentType: this.appointmentType ?? appointmentType.FutureAppointments
    };

    this.detailSignal.set(value);
  }

  get shouldShowDocumentsTable(): boolean {
    // future appointments non-cancelled or rescheduled
    if(this.appointment.status.toLowerCase() === 'expected'){
      return false;
    }

    // should catch other future appointments
    if(this.appointment.date != null){
      let date = new Date(this.appointment.date);
      if(date > new Date()){
        return false;
      }
    }

    if (this.showDocumentsTable != null) {
      return this.showDocumentsTable;
    }

    return this.appointmentType !== appointmentType.FutureAppointments;
  }

  get formatAppointmentDate(): string {
    return `${this.appointment.date}, ${this.appointment.time}`;
  }
}
